import apolloClient from 'api/apolloClient';
import { CartBrowsingCriteria } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { QuoteStatus } from 'types/zywaveService';
import { GET_QUOTE_STATUS } from 'api/queries/zywaveService';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';

export const getQuoteStatus = async (
  groupId: string,
  productLineId: ProductLineId,
  browsingCriteria: CartBrowsingCriteria,
): Promise<QuoteStatus> => {
  const res = await apolloClient.query<{ getQuoteStatus: QuoteStatus }>({
    query: GET_QUOTE_STATUS,
    fetchPolicy: 'no-cache',
    variables: { groupId, productLineId, browsingCriteria },
  });
  return res.data.getQuoteStatus;
};
